export const DATAMODES = {
  BORROW: "borrow",
  PORTFOLIO: "portfolio"
};
